import axios from "axios";
import { API } from "./api";

const ownerApi = axios.create({ baseURL: API });

ownerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("cs_owner_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

ownerApi.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("cs_owner_token");
      if (window.location.pathname.startsWith("/owner") && window.location.pathname !== "/owner/login") {
        window.location.href = "/owner/login";
      }
    }
    return Promise.reject(error);
  }
);

export const owner = {
  login: (email, password) => ownerApi.post("/owner/auth/login", { email, password }).then((r) => r.data),
  me: () => ownerApi.get("/owner/auth/me").then((r) => r.data),
  overview: () => ownerApi.get("/owner/platform/overview").then((r) => r.data),
  listMerchants: (search) => ownerApi.get("/owner/merchants", { params: search ? { search } : {} }).then((r) => r.data),
  getMerchant: (id) => ownerApi.get(`/owner/merchants/${id}`).then((r) => r.data),
  updateMerchant: (id, data) => ownerApi.patch(`/owner/merchants/${id}`, data).then((r) => r.data),
  deleteMerchant: (id) => ownerApi.delete(`/owner/merchants/${id}`).then((r) => r.data),
  impersonate: (id) => ownerApi.post(`/owner/merchants/${id}/impersonate`).then((r) => r.data),
  auditLogs: (limit = 100) => ownerApi.get("/owner/audit-logs", { params: { limit } }).then((r) => r.data),
  flags: () => ownerApi.get("/owner/feature-flags").then((r) => r.data),
  updateFlag: (key, enabled) => ownerApi.patch(`/owner/feature-flags/${key}`, { enabled }).then((r) => r.data),
  merchantCustomers: (id) => ownerApi.get(`/owner/merchants/${id}/customers`).then((r) => r.data),
  // 2FA
  tfaStatus: () => ownerApi.get("/owner/2fa/status").then((r) => r.data),
  tfaSetup: () => ownerApi.post("/owner/2fa/setup").then((r) => r.data),
  tfaEnable: (code) => ownerApi.post("/owner/2fa/enable", { code }).then((r) => r.data),
  tfaDisable: (code) => ownerApi.post("/owner/2fa/disable", { code }).then((r) => r.data),
  login2fa: (email, password, code) => ownerApi.post("/owner/auth/login-2fa", { email, password, code }).then((r) => r.data),
  // CMS
  updateLanding: (data) => ownerApi.patch("/owner/cms/landing", data).then((r) => r.data),
  updateLandingFull: (data) => ownerApi.patch("/owner/cms/landing-full", data).then((r) => r.data),
};

export { API };
